import React from 'react';
import { EmbeddedCheckoutProvider, EmbeddedCheckout as StripeEmbeddedCheckout } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Fetch publishable key from backend to ensure it always matches the secret key's account
// Falls back to env variable / hardcoded key if fetch fails
const stripePromise = fetch('/billing/stripe-config')
  .then(res => res.json())
  .then(data => loadStripe(data.publishableKey || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_51SQwG5K0AIIy4r9bTLiYo25uxVL55gfxltCxYyTFr1kim3EmgUHxMiWR8iwYUqB9IfTYYjhPgyaKKzD9Ve3Rx3s900mrEwF4Lj'))
  .catch(() => loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_live_51SQwG5K0AIIy4r9bTLiYo25uxVL55gfxltCxYyTFr1kim3EmgUHxMiWR8iwYUqB9IfTYYjhPgyaKKzD9Ve3Rx3s900mrEwF4Lj'));

export const EmbeddedCheckout = ({ clientSecret, onComplete }) => {
  const options = { clientSecret };

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={options}
      >
        <StripeEmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};
